import React, { useEffect } from 'react';
import { Button, ButtonGroup, FormGroup, Label, Spinner } from 'reactstrap';
import TestPlayer from './TestPlayer';

const VoicesGroup = ({
  vendors,
  selectedVendor,
  setSelectedVendor,
  languages,
  loading,
  selectedLanguage,
  setSelectedLanguage,
  voices,
  selectedVoices,
  setSelectedVoices,
  selectedVoicesMatch,
  handleSelectVoice,
  clearAllVoices,
  formik,
  values,
  errors,
  touched
}) => {
  useEffect(() => {
    setSelectedVendor(vendors[0]);
  }, [loading]);

  // console.log('vendors', vendors);
  const addAllVoicesInSelectedVendor = () => {
    let allVoices = [];
    languages.forEach((language) => {
      allVoices.push(...language.voices);
    });
    allVoices = allVoices.filter((voice) => !selectedVoicesMatch(voice));

    setSelectedVoices([...selectedVoices, ...allVoices]);
  };

  return (
    <FormGroup className="d-flex flex-column voices-group">
      <Label for="vendor">Vendor</Label>
      <ButtonGroup className="d-flex">
        {vendors.map((vendor, index) => (
          <Button
            key={index}
            color={selectedVendor === vendor ? 'secondary' : 'primary'}
            className="flex-fill"
            onClick={() => setSelectedVendor(vendor)}
            active={selectedVendor === vendor}
            title={vendor}>
            {vendor}
          </Button>
        ))}
      </ButtonGroup>
      <Button
        color="primary"
        className="add-all-voices-btn"
        onClick={() => {
          addAllVoicesInSelectedVendor();
        }}>
        Add All Voices In Selected Vendor
      </Button>
      <Label for="language">Language</Label>
      <ButtonGroup className="d-flex  mb-2 justify-content-center align-items-center flex-wrap button-group-select">
        {loading ? (
          <Spinner color="primary" />
        ) : (
          languages.map((language, index) => (
            <Button
              key={index}
              color={selectedLanguage === language.language ? 'secondary' : 'primary'}
              className="flex-fill button-group-select_button"
              onClick={() => setSelectedLanguage(language.language)}
              active={selectedLanguage === language.language}
              title={language.voices.length + ' voices'}>
              {language.language}{' '}
              <span style={{ fontSize: '10px', color: '#f5f5f5' }}>
                ({language.voices.length}) {language.voices.length === 1 ? 'Voice' : 'Voices'}
              </span>
            </Button>
          ))
        )}
      </ButtonGroup>
      {selectedLanguage && <Label for="voices">Voices</Label>}
      <ButtonGroup className="d-flex justify-content-center align-items-center flex-wrap button-group-select">
        {voices.map((voice, index) => (
          <Button
            key={index}
            color={selectedVoicesMatch(voice) ? 'danger' : 'primary'}
            className="flex-fill button-group-select_button"
            onClick={() => {
              formik.setFieldValue('voices', [...selectedVoices, voice]);
              handleSelectVoice(voice);
            }}
            active={selectedVoicesMatch(voice)}>
            {voice.name} ({voice.gender})
          </Button>
        ))}
      </ButtonGroup>
      {selectedVoices && (
        <Label for="voices" className="label-select">
          Selected Voices
          <span>{selectedVoices.length}</span>
        </Label>
      )}
      <ButtonGroup className="d-flex justify-content-center align-items-center flex-wrap button-group-select">
        {selectedVoices?.map((voice, index) => (
          <Button
            key={index}
            color="secondary"
            className="flex-fill button-group-select_button"
            onClick={() => {
              formik.setFieldValue(
                'voices',
                selectedVoices.filter((v) => v !== voice)
              );
              handleSelectVoice(voice);
            }}
            active={selectedVoicesMatch(voice)}
            title={voice.language + ' - ' + voice.vendor}>
            {voice.name} ({voice.gender})<br />
            <span style={{ fontSize: '10px', color: '#505050' }}>
              {voice.language}-{voice.vendor}
            </span>
          </Button>
        ))}
      </ButtonGroup>
      {errors.voices && touched.voices && <p className="text-danger">{errors.voices}</p>}
      <Button
        color="danger"
        className="clear-voices-btn"
        disabled={selectedVoices?.length === 0}
        onClick={() => {
          formik.setFieldValue('voices', [...selectedVoices, ...values.voices]);
          clearAllVoices();
        }}>
        Clear All Voices
      </Button>
    </FormGroup>
  );
};

export default VoicesGroup;
